export const config = {
  propsName: 'renderProps',
  name: 'SpMessageNotify',
  type: 'activeTmpsConfig',
  icon: 'el-icon-setting',
  cnName: '消息通知',
  tooltip: 'SpTmp模版tooltip',
  base: {
    margin: [0, 0, 0, 0]
  },
  props: [
    {
      tooltip: 'fontWeight',
      type: () => import('@/weappTmps/comps/fontWeight/index.vue'),
      cmpPath: '/comps/fontWeight/index.vue',
      key: 'fontWeight',
      bind: {
        // label: '排列方式',
      },
      on: {},
      value: null
    },
    {
      tooltip: '增加文本',
      type: 'sp-addOption',
      key: 'options',
      bind: {
        label: '增加文本'
      },
      on: {},
      value: []
    },
    {
      type: () => import('@/weappTmps/comps/color/index.vue'),
      cmpPath: '/comps/color/index.vue',
      key: 'color',
      bind: {
        label: '字体颜色'
      },
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/backgroundColor/index.vue'),
      cmpPath: '/comps/backgroundColor/index.vue',
      key: 'backgroundColor',
      bind: {
        label: '背景色'
      },
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'margin',
      bind: {
        label: '边距'
      },
      on: {},
      value: null
    }
  ]
}
